var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRomania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9565 1.24391C24.7898 0.440078 22.4464 1.03982e-08 20 1.03982e-08C17.5536 -7.81146e-05 15.2102 0.440078 13.0435 1.24391L11.3044 19.9999L13.0435 38.7559C15.2101 39.56 17.5535 40 20 40C22.4463 40 24.7899 39.56 26.9565 38.7559L28.6956 20L26.9565 1.24391Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 20C40.0001 11.4008 34.5726 4.0698 26.9566 1.24402V38.7562C34.5726 35.9301 40 28.5994 40.0001 20Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 19.9999C0 28.5994 5.4275 35.9301 13.0434 38.7561L13.0434 1.24408C5.4275 4.06986 0 11.4006 0 19.9999H0Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRomania);
export default __webpack_public_path__ + "static/media/romania.30d013ede1c3959972c14dd03d435233.svg";
export { ForwardRef as ReactComponent };